import { FinBoxBankConnect } from "finbox-bank-connect-js";
import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import styled from "styled-components";
import Finboxsdk from "../components/Finboxsdk";
import BreadCrumbsNavbar from "../components/BreadCrumbsNavbar";
import { MdClose } from "react-icons/md";
import help from "./images/helpIcon.svg";
import {
  Bold16,
  calcTime,
  Card,
  getRandomLinkId,
  Main,
  SDK,
  Container,
  LabelWithInput,
  ButtonCore,
  Banner1,
} from "../components/common";
import Navbar from "../components/Navbar";
import StartingModal from "../components/StartingModal";
import { ProceedButton } from "../components/common";
import BCEmptyState from "./BCEmptyState";
import StatementTable from "./StatementTable";
import AppContext from "../context/AppContext";
import { IoIosCloseCircleOutline } from "react-icons/io";
import moment from "moment";
const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  opacity: 1;
  width: 100vw;
  height: 100vh;
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: start;
`;
const CreateNewButton = styled.div`
  font-size: 14px;
  font-weight: 700;
  background-color: ${(props) => (props.isbankLoaded ? "#24ca7a" : "#cecece")};
  color: ${(props) => (props.isbankLoaded ? "white" : "#777777")};
  border-radius: 2px;
  padding: 7px 20px;
  display: flex;
  align-items: center;
  width: fit-content;
  cursor: ${(props) => (props.isbankLoaded ? "pointer" : "default")};
  /* margin: -14px 40px 14px 0; */
  &:hover {
    background-color: ${(props) =>
      props.isbankLoaded ? "#139e66" : "#cecece"};
  }
`;
const TopBar = styled.div`
  padding-top: 1px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  @media (max-width: 786px) {
    flex-wrap: wrap;
  }
`;
const Search = styled.div`
  margin: 0 25px 0 35px;
  display: flex;
  width: 100%;
  align-items: center;
  order: 0;
  @media (max-width: 786px) {
    order: 1;
    width: -webkit-fill-available;
    margin: 15px -16px 15px 0px;
  }
`;
const ButtonSearch = styled.div`
  /* font-size: 14px; */
  /* font-weight: 700; */
  background-color: #11a1f1;
  color: white;
  border-radius: 0 2px 2px 0;
  padding: 7px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* width: fit-content; */
  cursor: pointer;
  /* margin: -14px 40px 14px 0; */
  &:hover {
    background-color: #58bdf5;
  }
  img {
    height: 20.8px;
  }
`;

function StatementList(props) {
  const context = useContext(AppContext);
  const [data, setData] = useState([]);
  const [manuallinkID, setManual] = useState(
    context.companyName !== "MAS Financial Pvt Ltd" &&
      context.companyName !== "MAS Financial Services Limited"
      ? true
      : false
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [trialExpired, setTrialExpired] = useState(false);
  const [showBankConnect, setShowBankConnect] = useState(false);
  const [isbankLoaded, setIsbankLoaded] = useState(false);
  const [clear, setClear] = useState(false);
  const [apiKey, setApiKey] = useState();
  const [linkID, setLinkID] = useState("");
  const [close, setClose] = useState(false);
  const [link, setLink] = useState("");
  const [val, setVal] = useState(context.askflag);
  let linkid = uuidv4();
  const timep = context.timep;
  const [src, setSrc] = useState();
  const [showsdk, setShowsdk] = useState(false);
  const [showmodal, setModal] = useState(true);
  let today = new Date(new Date().setDate(new Date().getDate() - 1));
  const d = new Date(today);
  //const toDate = d.toLocaleDateString();
  const f = new Date(addMonths(d, -timep));
  // const fromDate = f.toLocaleDateString();
  const fromDate = moment(f).format("DD/MM/YYYY");
  const toDate = moment(today).format("DD/MM/YYYY");
  const history = useHistory();
  useEffect(() => {
    fetchStatementList();
    fetchApiKey();
    getQueryStatus();
    setTrialExpired(context.daysLeft < 1);
  }, [clear, context.stage]);

  const createNew = () => {
    console.log("Api key", apiKey);
    setShowBankConnect(true);
    getSession();
    setShowsdk(true);
    setModal(true);
    // history.push("/bankconnect/upload");
  };

  const onBankConnectExit = () => {
    setShowBankConnect(false);
  };
  const getQueryStatus = async () => {
    let fT = context.token;
    const ftData = JSON.parse(fT);
    var myHeaders = new Headers();
    myHeaders.append("token", ftData.Token);
    const requestOptions = {
      method: "GET",
      redirect: "follow",
      headers: myHeaders,
    };
    let res;
    res = await fetch(
      `https://dashboardapi.finbox.in/v1/proxy/bank_connect_preferred_month_count_new?stage=${context.stage}`,
      requestOptions
    );

    console.log("res", res);
    const json = await res.json();
    if (res.ok) {
      if (json.month_count !== null) {
        context.updateTimep(json.month_count);
        context.updateAnyFlag(false);
      } else if (json.ask_every_time !== null) {
        context.updateaskFlag(json.ask_every_time);
        context.updateAnyFlag(false);
      } else if (json.accept_anything !== null) {
        context.updateAnyFlag(json.accept_anything);
      }
    } else {
      console.log(json.error);
    }
  };

  // const getQueryStatus = async () => {
  //   let fT = context.token;
  //   const ftData = JSON.parse(fT);
  //   var myHeaders = new Headers();
  //   myHeaders.append("token", ftData.Token);

  //   const requestOptions = {
  //     method: "GET",
  //     redirect: "follow",
  //     headers: myHeaders,
  //   };
  //   let res;
  //     res = await fetch(
  //       `https://dashboardapi.finbox.in/v1/proxy/bank_connect_preferred_month_count?stage=prod`,
  //       requestOptions
  //     );
  //   console.log("res", res);
  //   const json = await res.json();
  //   if (res.ok) {
  //     context.updateTimep(json.Data.value);
  //     if (!json.Data.status) {
  //       context.updateaskFlag(!json.Data.status);
  //     }
  //   } else {
  //     console.log(json.error);
  //   }
  // };

  const onBankConnectSuccess = (payload) => {
    console.log("Payload -> ", payload);
    localStorage.setItem("bankConnectLinkId", payload.linkId);
    window.location.href = "/bankconnect/results/" + payload.entityId;
  };

  const fetchApiKey = async () => {
    const resp = context.token;
    const respJSON = JSON.parse(resp);
    var myHeaders = new Headers();
    myHeaders.append("token", respJSON.Token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    const dresp = await fetch(
      "https://dashboardapi.finbox.in/v1/developer/bank_connect",
      requestOptions
    );
    const result = await dresp.json();
    const envs = result.Data.Env;
    console.log("envs", envs);
    let myAPIKey = null;

    if (context.stage in envs) {
      myAPIKey = envs[context.stage][0]["Keys"][0].Value;
      context.updateBankConnectApiKey(myAPIKey);
      setApiKey(myAPIKey);
    } else {
      history.push("/empty/bank_connect");
    }
    setIsbankLoaded(true);
  };

  const fetchStatementList = async (page = 1) => {
    let fT = context.token;
    const ftData = JSON.parse(fT);
    var myHeaders = new Headers();
    myHeaders.append("token", ftData.Token);
    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };
    let response;
    try {
      response = await fetch(
        `https://dashboardapi.finbox.in/v1/usage/bank_connect_entities?page=${page}&max=10&link_id=${linkID}&stage=${context.stage}`,
        requestOptions
      );
      if (response.status == 400) {
        window.location.href = "/bankconnect";
        return;
      }
    } catch (err) {
      context.removeToken();
      return;
    }
    const resp = await response.text();
    const json = JSON.parse(resp);
    if (json.Status) {
      setData(json.Data.Items);
      setTotalPages(json.Data.MaxPages == 0 ? "1" : json.Data.MaxPages);
    }
    setLoading(false);
    // setLinkID("");
  };

  const checkIfExpired = (diff) => {
    return diff < 0;
  };

  const openBankConnect = () => {
    console.log("Expired  ", trialExpired);
    console.log("Expired  ", showBankConnect);
    if (context.daysLeft < 1) {
      setShowBankConnect(true);
      setTrialExpired(true);
    } else {
      isTrial();
    }
  };
  const ApiCall = () => {
    if (!aflag) {
      if (
        context.companyName !== "MAS Financial Pvt Ltd" &&
        context.companyName !== "MAS Financial Services Limited"
      ) {
        getSession();
      }
      setShowsdk(true);
      openBankConnect();
      setModal(true);
      setClose(true);
      setClear(!clear);
    } else {
      setModal(true);
      openBankConnect();
    }
  };
  function addMonths(date, months) {
    date.setMonth(date.getMonth() + months);
    return date;
  }

  const getSession = async () => {
    let fT = context.token;
    const ftData = JSON.parse(fT);
    var myHeaders = new Headers();
    myHeaders.append("token", ftData.Token);
    const requestBody = {
      stage: context.stage,
      fromDate: context.any ? undefined : fromDate,
      toDate: context.any ? undefined : toDate,
      linkID: link || linkid,
    };
    const requestOptions = {
      method: "POST",
      redirect: "follow",
      headers: myHeaders,
      body: JSON.stringify(requestBody),
    };
    let res;
    res = await fetch(
      "https://dashboardapi.finbox.in/v1/proxy/bank_connect_session",
      requestOptions
    );
    console.log(res);
    const json = await res.json();
    console.log(json);
    if (res.ok) {
      setSrc(json.redirect_url);
      setShowsdk(true);
      let payload;
      window.addEventListener("message", function (event) {
        console.log("Event -> ", event);
        if (event.data.status == "exit") {
          setShowsdk(false);
          setModal(false);
          fetchStatementList();
        }
        if (event.data.status == "success") {
          localStorage.setItem("bankConnectLinkId", event.data.payload.linkId);
          payload = event.data.payload;
          if (payload.entityId != null) {
            history.push("/bankconnect/results/" + payload.entityId);
            // window.open("/bankconnect/results/" + payload.entityId, "_self");
          }
          setShowsdk(false);
          setModal(false);
          event.stopPropagation();
        }
      });
    } else {
      setShowsdk(false);
      setModal(false);
      console.log(json.Error);
    }
  };

  const isTrial = async () => {
    let fT = context.token;
    const ftData = JSON.parse(fT);
    var myHeaders = new Headers();
    myHeaders.append("token", ftData.Token);

    let CurrentDate = new Date();

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    let response = await fetch(
      "https://dashboardapi.finbox.in/v1/user/config",
      requestOptions
    );
    const result = await response.text();
    const json = JSON.parse(result);
    if (!checkIfExpired(calcTime(json.Data.ExpiryDate))) {
      createNew();
    }
  };
  console.log(props.location.pathname);
  console.log("askflagggg=> ", context.askflag);
  const aflag = JSON.parse(context.askflag);
  return (
    <Main style={{ overflowY: "hidden" }}>
      {showBankConnect ? (
        aflag ? (
          <>
            <Finboxsdk
              showmodal={showmodal}
              setModal={setModal}
              askflag={aflag}
              setData={setData}
              setTotalPages={setTotalPages}
              data={data}
              currentPage={currentPage}
              onPrimaryClick={() => {
                setShowBankConnect(true);
                setTrialExpired(false);
                context.updateaskFlag(false);
              }}
              onClose={props.onClose}
            />
          </>
        ) : !manuallinkID ? (
          <>
            <Overlay style={{ display: close ? "flex" : "none" }}>
              <Banner1
                style={{
                  zIndex: "20",
                  marginTop: "15px",
                  padding: "10px 20px",
                }}
              >
                <div style={{ marginLeft: "270px" }}>
                  <button
                    style={{
                      background: "white",
                      borderColor: "white",
                      borderWidth: "0px",
                      tabSize: "20px",
                      cursor: "pointer",
                      padding: "10px",
                    }}
                    onClick={() => {
                      setClose(false);
                      setLink("");
                    }}
                  >
                    <MdClose />
                  </button>
                </div>
                <br />
                <img
                  src="https://finbox-cdn.s3.ap-south-1.amazonaws.com/assets/dashboard/modal.svg"
                  style={{ width: "60%", marginTop: "20px" }}
                />
                <br />
                <br />
                <div style={{ width: "100%" }}>
                  <span
                    style={{
                      color: "#3e3e3e",
                      fontWeight: "500",
                      marginBottom: "10px",
                    }}
                  >
                    Link Id
                  </span>
                  <input
                    value={link}
                    onChange={(e) => {
                      setLink(e.target.value);
                    }}
                    placeholder="Enter your link Id"
                    style={{ padding: "8px", width: "100%", marginTop: "6px" }}
                  />
                  <div
                    style={{
                      background: "#0075ff10",
                      padding: "5px",
                      width: "100%",
                      marginTop: "10px",
                      borderRadius: "4px",
                      fontSize: ".6rem",
                      color: "#0075ff",
                      display: "flex",
                      gap: "3px",
                    }}
                  >
                    <img
                      src={help}
                      style={{
                        height: ".7rem",
                        width: ".7rem",
                        alignItems: "center",
                        color: "#0075ff",
                        margin: "3px",
                      }}
                    />
                    <div>
                      LinkID can be any identifier that can be used to uniquely
                      identify the user at your end.
                    </div>
                  </div>
                </div>
                <ProceedButton
                  onClick={() => {
                    setManual(true);
                    getSession();
                  }}
                  style={{
                    width: "100%",
                    marginTop: "25px",
                    padding: "14px 25px",
                  }}
                >
                  Proceed
                </ProceedButton>
              </Banner1>
            </Overlay>
          </>
        ) : (
          <Finboxsdk
            src={src}
            showsdk={showsdk}
            linkId={getRandomLinkId()}
            setShowsdk={setShowsdk}
            showmodal={showmodal}
            setModal={setModal}
          />
        )
      ) : (
        ""
      )}

      <BreadCrumbsNavbar
        color="blue"
        loc={[
          { name: "BankConnect", link: "/bankconnect" },
          { name: "Statements", link: props.location.pathname },
        ]}
      />
      <Container style={{ background: "white", overflowY: "scroll" }}>
        {loading || data.length != 0 ? (
          <div>
            <TopBar>
              <Bold16 style={{ minWidth: "max-content" }}>All Uploads</Bold16>

              {/* <div style={{ flexGrow: "1", display: "flex" }}> */}
              <Search>
                <LabelWithInput
                  name="Search"
                  value={linkID}
                  readOnly
                  placeholder="Enter Link ID"
                  search="yes"
                  onChange={(e) => {
                    setLinkID(e.target.value);
                    // console.log(e.target.value);
                  }}
                  style={{ flexGrow: "1" }}
                  onKeyPress={(e) =>
                    e.charCode == 13 ? fetchStatementList() : ""
                  }
                />
                {/* </div> */}
                <ButtonSearch
                  style={{
                    marginRight:
                      linkID == "" ? "16px" : linkID != "" ? "0" : "",
                  }}
                  onClick={() => fetchStatementList()}
                >
                  <img
                    src="https://finbox-cdn.s3.ap-south-1.amazonaws.com/assets/dashboard/search.svg"
                    id="search"
                  />
                </ButtonSearch>
                <IoIosCloseCircleOutline
                  onClick={() => {
                    setLinkID("");
                    setClear(!clear);
                  }}
                  style={{
                    position: "relative",
                    right: "84px",
                    cursor: "pointer",
                    display:
                      linkID == "" ? "none" : linkID != "" ? "block" : "",
                  }}
                />
              </Search>

              <CreateNewButton
                isbankLoaded={isbankLoaded}
                onClick={(e) => ApiCall()}
                style={{ minWidth: "max-content" }}
              >
                Launch Client SDK
              </CreateNewButton>
            </TopBar>

            <Card
              style={{
                display: "flex",
                flexDirection: "column",
                borderRadius: 10,
                border: "1px solid #ECECEC",
                padding: 0,
                overflowX: "scroll",
                height: "auto",
              }}
            >
              <StatementTable
                loading={loading}
                data={data}
                currentPage={currentPage}
                totalPages={totalPages}
                fetchData={(page) => {
                  setCurrentPage(page);
                  fetchStatementList(page);
                }}
              />
            </Card>
          </div>
        ) : data.length == 0 && linkID != "" ? (
          <div>
            <TopBar>
              <Bold16 style={{ minWidth: "max-content" }}>All Uploads</Bold16>

              {/* <div style={{ flexGrow: "1", display: "flex" }}> */}
              <Search>
                <LabelWithInput
                  name="Search"
                  value={linkID}
                  readOnly
                  placeholder="Enter Link ID"
                  search="yes"
                  onChange={(e) => {
                    setLinkID(e.target.value);
                    // console.log(e.target.value);
                  }}
                  style={{ flexGrow: "1" }}
                  onKeyPress={(e) =>
                    e.charCode == 13 ? fetchStatementList() : ""
                  }
                />
                {/* </div> */}
                <ButtonSearch
                  style={{
                    marginRight:
                      linkID == "" ? "16px" : linkID != "" ? "0" : "",
                  }}
                  onClick={() => fetchStatementList()}
                >
                  <img
                    src="https://finbox-cdn.s3.ap-south-1.amazonaws.com/assets/dashboard/search.svg"
                    id="search"
                  />
                </ButtonSearch>
                <IoIosCloseCircleOutline
                  onClick={() => {
                    setLinkID("");
                    setClear(!clear);
                  }}
                  style={{
                    position: "relative",
                    right: "84px",
                    cursor: "pointer",
                    display:
                      linkID == "" ? "none" : linkID != "" ? "block" : "",
                  }}
                />
              </Search>

              <CreateNewButton
                isbankLoaded={isbankLoaded}
                askflag={context.askflag}
                onClick={(e) => ApiCall()}
                style={{ minWidth: "max-content" }}
              >
                Launch Client SDK
              </CreateNewButton>
            </TopBar>

            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                marginTop: "50px",
              }}
            >
              <img
                src="https://finbox-cdn.s3.ap-south-1.amazonaws.com/assets/dashboard/No+data-amico+1.svg"
                height={200}
              />
              <p className="empty-title h5">No records found</p>
            </div>
          </div>
        ) : (
          <BCEmptyState isbankLoaded={isbankLoaded} ApiCall={ApiCall}/>
        )}
      </Container>
    </Main>
  );
}

export default StatementList;
